import { capitalizeAllIfLower, formatDate } from '@btime/helpers'
import { compose, prop, propOr } from 'ramda'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { UserAvatar } from '../../../../../../components/presentation/Avatar'
import { useColor } from '../../../../../../packages/kiti/components/theme/_hooks/colors'
import { useEventsState } from './_load/EventsLoader'
import Expandable from '../../../../../../components/helpers/Expandable'
import FlexGrid from '../../../../../../components/structure/FlexGrid'
import Panel from '../../../../../../components/structure/Panel'
import Text, { SmallText } from '../../../../../../packages/kiti/components/presentation/Text'
import Tooltip from '../../../../../../components/helpers/Tooltip'
import { useServiceOrder } from '../../../_load/ServiceOrderLoader'
import { incrementCheckout, shouldIncrementCheckout } from '../../../../../../utils/helpers/serviceOrder'

const EventItem = ({ item }) => {
  const { t } = useTranslation()
  const user = prop('createdBy', item) || prop('user', item)
  const userName = compose(capitalizeAllIfLower, propOr('anônimo', 'name'))(user)
  const serviceStatus = prop('status', item)
  const statusName = prop('name', serviceStatus)
  const color = useColor(serviceStatus.color)
  const serviceOrder = useServiceOrder()
  const shouldIncrementEventDate = item.eventDate >= serviceOrder.endDate && shouldIncrementCheckout(serviceOrder)
  const date = formatDate(
    'DD/MM/YY HH:mm',
    shouldIncrementEventDate ? incrementCheckout(item.eventDate) : item.eventDate
  )

  return (
    <Panel lineBorder noMargin smallPadding borderLeftColor={color}>
      <Text weight="500">
        {userName} {t('status.pastAction.' + statusName)}
      </Text>

      {!!item?.reason?.name && (
        <Tooltip actionContent={`Motivo: ${item.reason.name}`} autoSize>
          {item.description}
        </Tooltip>
      )}
      <FlexGrid justify="space-between" gutter={0.3}>
        <SmallText size="xsmall">{date}</SmallText>
        <UserAvatar size="xsmall" user={user} />
      </FlexGrid>
    </Panel>
  )
}

const EventsList = () => {
  const { events } = useEventsState()
  return (
    <Expandable disabled={events.length < 6}>
      <FlexGrid direction="column" gutter={0.3} align="stretch" justify="flex-start">
        {events.map(item => (
          <EventItem key={item.id} item={item} />
        ))}
      </FlexGrid>
    </Expandable>
  )
}

export default EventsList
